import React from "react";
import {
  Box,
  Container,
  Typography,
  Paper,
  Grid,
  IconButton,
} from "@mui/material";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import Brightness7Icon from "@mui/icons-material/Brightness7";

// ✅ Function to generate client ID
function generateClientId(clientName, createdAt) {
  if (!clientName || !createdAt) return "N/A";

  const prefix = clientName.substring(0, 3).toUpperCase(); // first 3 letters
  const date = new Date(createdAt);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // 01-12

  return `${prefix}-${year}${month}`;
}

export default function Header({ darkMode, setDarkMode, clientName, createdAt }) {
  const clientId = generateClientId(clientName, createdAt);

  return (
    <Paper
      square
      elevation={1}
      sx={{
        borderBottom: 1,
        borderColor: "divider",
        bgcolor: "background.paper",
      }}
    >
      <Container
        maxWidth={false}
        sx={{
          px: { xs: 2, sm: 3, md: 4 },
        }}
      >
        <Box py={3}>
          <Grid container justifyContent="space-between" alignItems="center">
            {/* Left section */}
            <Grid item>
              <Box display="flex" alignItems="center">
                <Box
                  component="img"
                  src="https://res.cloudinary.com/dr7y4kbvc/image/upload/v1755440563/pnp_logo_yitg87.png"
                  alt="PNP Logo"
                  sx={{
                    width: "auto",
                    height: 48,
                    borderRadius: 2,
                    objectFit: "cover",
                  }}
                />

                <Box ml={2}>
                  <Typography
                    variant="h5"
                    fontWeight="bold"
                    color="text.primary"
                  >
                    PNP ACCOUNTS AND TAX ADVISORS
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Financial Service Tracking
                  </Typography>
                </Box>
              </Box>
            </Grid>

            {/* Right section */}
            <Grid item>
              <Box display="flex" alignItems="center" gap={2}>
                <Box textAlign="right">
                  <Typography variant="body2" color="text.secondary">
                    Client ID
                  </Typography>
                  <Typography
                    variant="body2"
                    fontFamily="monospace"
                    fontWeight="bold"
                    color="text.primary"
                  >
                    {clientId}
                  </Typography>
                </Box>

                <IconButton
                  color="inherit"
                  onClick={() => setDarkMode(!darkMode)}
                >
                  {darkMode ? <Brightness7Icon /> : <Brightness4Icon />}
                </IconButton>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </Paper>
  );
}
